var map = {
	"./aave-wei.svg": 1481,
	"./active-eye-blue.svg": 1482,
	"./ape-wei.svg": 1483,
	"./axs-wei.svg": 1484,
	"./dai-wei.svg": 1485,
	"./dot-planck.svg": 1486,
	"./echf.svg": 1487,
	"./eeur.svg": 1488,
	"./frax-wei.svg": 1489,
	"./link-wei.svg": 1490,
	"./mkr-wei.svg": 1491,
	"./rai-wei.svg": 1492,
	"./shib-wei.svg": 1493,
	"./steth-wei.svg": 1494,
	"./uatom.svg": 1495,
	"./uausdc.svg": 1496,
	"./uaxl.svg": 1497,
	"./ujuno.svg": 1498,
	"./uluna.svg": 1499,
	"./ungm.svg": 1500,
	"./uni-wei.svg": 1501,
	"./uphoton.svg": 1502,
	"./uusd.svg": 1503,
	"./uusdc.svg": 1504,
	"./uusdt.svg": 1505,
	"./wavax-wei.svg": 1506,
	"./wbnb-wei.svg": 1507,
	"./wbtc-satoshi.svg": 1508,
	"./wdev-wei.svg": 1509,
	"./weth-wei.svg": 1510,
	"./wftm-wei.svg": 1511,
	"./wglmr-wei.svg": 1512,
	"./wmatic-wei.svg": 1513,
	"./xcn-wei.svg": 1514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;